<template>
  <el-drawer :withHeader="false" :visible.sync="open" direction="rtl" :before-close="handleClose" size="666px">
    <!-- <div class="close">
      收起
    </div> -->
    <div class="drawer-header">
      <div style="padding-top:20px;display: flex;">
        <div class="start-label" />
        <span class="text">查看库房详情</span>
      </div>
    </div>
    <div class="info">
      <div class="triangle"></div>
      <div class="info-conten">
        <span style="font-size:14px;font-weight:bold">当前库房级别: </span>
        <span style="margin-left:10px;font-size:14px;color:#E8B23D">{{form.categoryName+ '库房'}}</span><br />
        <span>关联科室: </span>
        <span style="margin-left:10px" v-for="item in form.deptInfos" :key="item.id">{{item.name}}</span><br />
        <span>启用状态：</span>
        <span style="margin-left:10px" :class="{enable: form.state==1}">已{{form.stateName}}</span>
      </div>
    </div>

    <div style="margin-left:20px;    padding-right: 52px;">
      <el-tabs v-model="activeTab" @tab-click="tabClick" stretch>
        <el-tab-pane v-for="item in tabs" :key="item.id" :name="item.id">
          <span slot="label"><span style="margin: 0 10px" :class="{'tab-active':activeTab==item.id}">{{item.name}}</span></span>
        </el-tab-pane>
      </el-tabs>
      <!-- <el-tabs v-model="activeTab" @tab-click="tabClick" stretch>
        <el-tab-pane v-for="item in AppCategory" :key="item.id" :name="item.id">
          <template slot="label">
            <span style="margin: 0 10px"> {{item.name}} </span>
          </template>
        </el-tab-pane>
      </el-tabs> -->

      <div style="margin-top:20px">
        <el-form v-show="activeTab == 0" label-width="160px">
          <el-form-item label="库房编码:" prop="no">
            <span class="value">{{form.no}}</span>
          </el-form-item>
          <el-form-item label="库房名称:" prop="name">
            <span class="value">{{form.name}}</span>
          </el-form-item>
          <el-form-item label="库房级别:" prop="categoryName">
            <span class="value">{{form.categoryName}}</span>
          </el-form-item>
          <el-form-item label="库房位置:">
            <span class="value">{{form.address}}</span>
          </el-form-item>
          <el-form-item label="库房管理员:">
            <span class="value">{{form.managerName}}</span>
          </el-form-item>
          <el-form-item label="联系方式:">
            <span class="value">{{form.phone}}</span>
          </el-form-item>
          <el-form-item label="验收提示对象:">
            <span class="value"> {{form.warnInfos ? form.warnInfos.map(e =>e.no + ' ' + e.name).join(';') : ""}}</span>
          </el-form-item>
          <el-form-item label="是否自动生成科室入库:">
            <span class="value">{{form.isAutoCreateDeptInStock == 1 ? "是" : "否"}}</span>
          </el-form-item>

          <el-form-item label="三级库启用状态:">
            <span class="value">{{form.isOpenThreeWarehouse == 1 ? "是" : "否"}}</span>
          </el-form-item>
        </el-form>

        <!-- <div v-show="activeTab == 1">
          <el-table :data="form.warnDetails" border style="width: 100%" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column prop="productName" label="产品名称" width="150"></el-table-column>
            <el-table-column prop="specName" label="规格型号" width="100"> </el-table-column>
            <el-table-column prop="max" label="库存上限" min-width="100"></el-table-column>
            <el-table-column prop="min" label="库存下限" min-width="100"></el-table-column>
            <el-table-column prop="warnName" label="提示对象" min-width="100" show-overflow-tooltip>
              <template slot-scope="scope">
                {{getWarnUserNames(scope.row)}}
              </template>
            </el-table-column>
          </el-table>

        </div> -->
        <div v-show="activeTab == 2">
          <el-table :data="form.details" border style="width: 100%" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column prop="no" label="货位编码" width="180"></el-table-column>
            <el-table-column prop="name" label="货位名称" width="100"> </el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>
          </el-table>

          <!-- <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="settingQuery.pageIndex" :total="settingTotal" @current-change="changePage">
          </el-pagination> -->
        </div>
      </div>
    </div>

  </el-drawer>
</template>

<script>
import { GetWarehouseById } from '@/api';
import GetDataMixin from "@/mixin/getData-mixin.js";
export default {
  components: {},
  name: 'warehouse-info',
  mixins: [GetDataMixin],
  data () {
    return {
      open: false,
      form: {
        details: [],
        settingDetails: []
      },
      // settingTotal: 0,
      activeTab: '0',
      // settingQuery: {
      //   pageIndex: 1,
      //   pageSize: 10
      // },
      tabs: [
        {
          id: '0',
          name: '库房基础信息'
        },
        // {
        //   id: '1',
        //   name: '库房阈值信息'
        // },
        {
          id: '2',
          name: '货位信息'
        }
      ],
      // warnNames: "",
    }
  },
  props: {
    show: {
      type: Boolean,
      default () {
        return false
      }
    },
    id: {
      type: Number,
      default () {
        return 0
      }
    }
  },
  watch: {
    'show' (val, oldVal) {
      this.open = val

      if (this.open) {
        this.getInfo()
      }
    },
  },
  methods: {
    handleClose () {
      this.$emit('handleClose');
    },
    getInfo () {
      GetWarehouseById({ id: this.id }).then(res => {
        this.form = res.returnData
        // if (res.returnData.warnInfos) {
        //   this.$set(this.form, 'warnNameArr', res.returnData.warnInfos.map(item => item.no + ' ' + item.name))
        //   this.warnNames = this.form.warnNameArr.join(';')
        // }

      })
    },
    tabClick (id) {
      // this.activeTab = id
    },
    getWarnUserNames (row) {
      // 调方法或者直接使用scope.row 
      // {{scope.row.warnInfos ? scope.row.warnInfos.map(e =>e.no + ' ' + e.name).join(';') : ""}
      return row.warnInfos ? row.warnInfos.map(item => item.no + ' ' + item.name).join(';') : ''
    }

  }
}
</script>

<style scoped>
div /deep/ .el-form-item__content {
  line-height: 20px !important;
  color: #606166;
  font-weight: 400;
}
div /deep/ .el-form-item__label {
  padding-bottom: 0 !important;
  line-height: 20px !important;
}
.el-form-item {
  margin-bottom: 5px !important;
}
.el-tabs {
  width: 400px;
  margin-bottom: 10px;
}
.tab-active {
  font-weight: bold !important;
}
</style>